export default __webpack_public_path__ + "static/media/Group485.fcf061d2.png";